var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","disabled":_vm.refreshing},on:{"click":_vm.refresh}},[_c('v-icon',[_vm._v("refresh")]),_c('span',[_vm._v("Recargar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }